import { T, __ } from 'stylewhere/i18n'
import CoreShippingStart, { ShippingStartParams } from 'core/pages/Shipping/ShippingStart'
import { askUserConfirmation, hideToast, showToast, showToastError } from 'stylewhere/shared/utils'
import { OperationReadingState, Sounds } from 'stylewhere/shared'
import { Shippings, ShippingSelectData } from 'stylewhere/api'
import { Asn } from 'stylewhere/api/types'
import { isSystemError } from 'core/shared/errors/SystemError'

interface ShippingStartProps {
  match: { params: ShippingStartParams }
  location: { state?: OperationReadingState }
  history: any
}

async function closeAsn({
  selected,
  operation,
  isModal
}: {
  selected: ShippingSelectData
  operation: any
  isModal: boolean
}): Promise<boolean> {
  const asnAttributes = selected.attributes ?? {}

  const toastId = showToast({
    title: __(T.misc.processing),
    description: __(T.messages.operation_in_progress),
    status: 'info'
  })
  try {
    await Shippings.confirmAsn(operation, selected.code, {
      ...asnAttributes,
      transactionDate: new Date().toISOString(),
      closedByCegid: true
    })
    showToast({
      title: __(T.misc.success),
      description: __(T.messages.operation_success),
      status: 'success'
    })
    if (toastId) hideToast(toastId)
    return true
  } catch (error) {
    showToastError(error, __(T.error.error), isModal)
    if (toastId) hideToast(toastId)
  }
  return false
}

export default class ShippingStart extends CoreShippingStart {
  onSelectAsnError = async (err: unknown, _selected: ShippingSelectData) => {
    let mustAskConfirmation = false
    let detailsAllowed: boolean = true
    let confirmMessage = ''
    if (isSystemError(err)) {
      switch (err.errorCodeName) {
        case 'ASN_CLOSED_BY_CEGID':
          confirmMessage = __(T.custom.confirm_force_received_text)
          mustAskConfirmation = true
          break
        case 'PROCESSED':
          confirmMessage = __(T.custom.confirm_force_received_sap_text)
          mustAskConfirmation = true
          detailsAllowed = false
          break
        case 'PARTIALLY_PROCESSED_SAP':
        case 'PARTIALLY_PROCESSED_BOTH':
          confirmMessage = __(T.custom.confirm_force_received_partially_sap_text)
          mustAskConfirmation = true
          detailsAllowed = false
          break
        default:
          break
      }
    }

    if (mustAskConfirmation) {
      const confirmForceClose = await askUserConfirmation(__(T.misc.confirm), confirmMessage)
      if (confirmForceClose) {
        // chiudi la spedizione passando l'attributo closedByCegid a true
        if (_selected?.id && _selected.code) {
          const refresh = await closeAsn({ selected: _selected, operation: this.operation, isModal: this.isModal })
          if (refresh) {
            Sounds.success()
            this.setState({ renderIteration: (this.state.renderIteration || 0) + 1 })
          }
          return
        }

        // error with data
        showToast({
          title: __(T.error.error),
          description: __(T.error.field_required, { label: 'ASN' }),
          status: 'error'
        })
        Sounds.error()
        this.navigateToAsn(_selected as Asn)
        return
      } else {
        if (detailsAllowed) {
          this.navigateToAsn(_selected as Asn)
        }
        return
      }
    }

    // error not managed
    showToastError(err, 'Start ASN Error', this.isModal)
  }
}
